import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="cms--ongoing-toggle"
export default class extends Controller {
  static targets = [ "ongoing", "endInputs" ]

  connect() {
  }

  toggle(event) {
    if (this.ongoingTarget.checked) {
      this.endInputsTarget.classList.add('hidden')
    } else {
      this.endInputsTarget.classList.remove('hidden')
    }
  }
}
